const addonInfo = {
  Stats: ['Stats tracking app', 'Detailed reports', 'Advanced Analytics'],
  Livestream: ['Fully Automated Video', 'Sponsor Integration', 'Video on-demand'],
  Engage: ['Automated socials', 'Facebook', 'Instagram'],
  Fans: ['Fan mobile app', 'Live stats & boxscores', 'Embeddable stats widgets'],
  Studio: ['Live production studio', 'Multi-camera control', 'Graphics'],
  ViewStats: ['Federation competition stats', 'Boxscores & standings', 'Player & team stats'],
}
export default addonInfo
